import React from 'react';
import { useSelector } from 'react-redux';
import {
	Navigate,
	Outlet,
	useLocation,
	useSearchParams
} from 'react-router-dom';
import { PORTAL_TYPES_DEFAULT_ROUTE } from '../constants/roles';

type Props = {
	isLoggedIn: boolean;
};

const PublicRoute = ({ isLoggedIn }: Props) => {
	const location = useLocation();
	const [searchParams] = useSearchParams();
	const currentRole = useSelector((state: any) => state.auth.currentRole);
	const portalType: string = currentRole?.portal_type;
	const defaultRoute = PORTAL_TYPES_DEFAULT_ROUTE[portalType];
	const id = searchParams.get('id');

	const verifier = searchParams.get('verifier');
	// console.log(location.pathname, verifier, id );
	if (
		location.pathname == '/auth/create-new-password' &&
		isLoggedIn &&
		id &&
		verifier
	) {
		// If opened reset password link when already logged in then let user see reset password page
		return <Outlet />;
	}

	return isLoggedIn ? <Navigate to={defaultRoute} /> : <Outlet />;
};

export default PublicRoute;
